import { ClockIcon } from 'lucide-react';
import React, { useState } from 'react';
import { IconButton } from '@material-tailwind/react';
import { PencilIcon, SaveIcon, XIcon } from 'lucide-react';
import { useUpdateUserMeetingRoomQuota } from '../../../custom-hooks/use-users';

const MeetingQuota = ({ customer }) => {
    const [isEditingMeetingQuota, setIsEditingMeetingQuota] = useState(false);
    const [meetingRoomQuota, setMeetingRoomQuota] = useState({
        monthlyHours: (customer?.meetingRoomQuota?.monthlyHours) / 60 || 0,
        meetingRoomHoursPerDay: (customer?.meetingRoomQuota?.meetingRoomHoursPerDay) / 60 || 0,
    });

    const updateUserMeetingRoomQuotaMutation = useUpdateUserMeetingRoomQuota();

    const handleSaveMeetingQuota = async () => {
        try {
            await updateUserMeetingRoomQuotaMutation.mutateAsync({ // TODO check if this invalidates queries
                userId: customer._id,
                data: {
                    monthlyHours: parseInt(meetingRoomQuota.monthlyHours) || 0,
                    meetingRoomHoursPerDay: parseInt(meetingRoomQuota.meetingRoomHoursPerDay) || 0,
                }
            });
            setIsEditingMeetingQuota(false);
        } catch (error) {
            console.error("Error updating meeting room quota:", error);
        }
    };

    const handleCancelEditMeetingQuota = () => {
        setMeetingRoomQuota({
            monthlyHours: (customer?.meetingRoomQuota?.monthlyHours) / 60 || 0,
            meetingRoomHoursPerDay: (customer?.meetingRoomQuota?.meetingRoomHoursPerDay) / 60 || 0,
        });
        setIsEditingMeetingQuota(false);
    };

    return (
        <div className="mt-6 pt-6 border-t">
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg font-semibold text-gray-700 flex items-center gap-2">
                    <ClockIcon size={16} />
                    Meeting Room Quota
                </h2>
                {!isEditingMeetingQuota ? (
                    <IconButton
                        variant="text"
                        size="sm"
                        onClick={() => setIsEditingMeetingQuota(true)}
                        className="rounded-full"
                    >
                        <PencilIcon size={16} />
                    </IconButton>
                ) : (
                    <div className="flex gap-2">
                        <IconButton
                            variant="gradient"
                            color="blue"
                            size="sm"
                            onClick={handleSaveMeetingQuota}
                            className="rounded-full"
                            disabled={updateUserMeetingRoomQuotaMutation.isLoading}
                        >
                            <SaveIcon size={16} />
                        </IconButton>
                        <IconButton
                            variant="outlined"
                            size="sm"
                            onClick={handleCancelEditMeetingQuota}
                            className="rounded-full"
                            disabled={updateUserMeetingRoomQuotaMutation.isLoading}
                        >
                            <XIcon size={16} />
                        </IconButton>
                    </div>
                )}
            </div>

            {!isEditingMeetingQuota ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="bg-gray-200 rounded-lg p-4">
                        <p className="text-sm text-gray-600 mb-1">Monthly Hours</p>
                        <p className="text-2xl font-bold text-gray-800">
                            {meetingRoomQuota?.monthlyHours || 0} hours
                        </p>
                    </div>
                    <div className="bg-gray-200 rounded-lg p-4">
                        <p className="text-sm text-gray-600 mb-1">Daily Limit</p>
                        <p className="text-2xl font-bold text-gray-800">
                            {meetingRoomQuota?.meetingRoomHoursPerDay || 0} hours/day
                        </p>
                    </div>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col">
                        <p className="text-sm text-gray-600">Monthly Hours ({meetingRoomQuota.monthlyHours} hours)</p>
                        <input
                            type="number"
                            className="w-full"
                            label="Monthly Hours"
                            value={meetingRoomQuota.monthlyHours}
                            max={30}
                            min={0}
                            step={1}
                            onChange={(e) => setMeetingRoomQuota({
                                ...meetingRoomQuota,
                                monthlyHours: e.target.value
                            })}
                            disabled={updateUserMeetingRoomQuotaMutation.isLoading}
                        />
                    </div>
                    <div className="flex flex-col">
                        <p className="text-sm text-gray-600">Daily Limit ({meetingRoomQuota.meetingRoomHoursPerDay} hours/day)</p>
                        <input
                            type="range"
                            className="w-full"
                            label="Daily Limit (hours/day)"
                            value={meetingRoomQuota.meetingRoomHoursPerDay}
                            max={10}
                            min={0}
                            step={1}
                            onChange={(e) => setMeetingRoomQuota({
                                ...meetingRoomQuota,
                                meetingRoomHoursPerDay: e.target.value
                            })}
                            disabled={updateUserMeetingRoomQuotaMutation.isLoading}
                        />

                    </div>
                </div>
            )}
        </div>
    );
};

export default MeetingQuota;